const footerClickTracking = {
  action: 'click',
  category: 'footer_sticky_navigation',
  type: 'footer_sticky_item',
  label: '',
};

export { footerClickTracking };
